import React, {useEffect} from "react";
import styles from "./DotDotDot.module.scss";
import {observer} from "mobx-react-lite";

export type DotDotDotProps = {
	interval?: number;
	totalDots?: number;
};

const DEFAULT_DOTS_INTERVAL = 200;
const DEFAULT_TOTAL_DOTS = 3;

/**
 * A loading animation of (by default) three dots in a row.
 * @param props.interval Delay time between dot (dis)appearance.  Defaults to 200ms.
 * @param props.totalDots Max number of dots to display.  Defaults to 3 dots.
 */
const DotDotDot: React.FC<DotDotDotProps> = (props) => {
	const interval = props.interval || DEFAULT_DOTS_INTERVAL;
	const totalDots = props.totalDots || DEFAULT_TOTAL_DOTS;

	const [dots, setDots] = React.useState(0);
	const dotIntervalRef = React.useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		// set a new interval
		setDots(0);
		dotIntervalRef.current = setInterval(() => {
			setDots((_dots) => (_dots + 1) % totalDots);
		}, interval);

		return () => {
			dotIntervalRef.current && clearInterval(dotIntervalRef.current);
		};
	}, [interval, totalDots]);

	const dotElements = new Array(totalDots).fill(0).map((_, i) => {
		return i < dots + 1 ? (
			<span className={styles.shownDot} key={i}>
				.
			</span>
		) : (
			<span className={styles.hiddenDot} key={i}>
				.
			</span>
		);
	});

	return <span className={styles.dotDotDot}>{dotElements}</span>;
};

export default observer(DotDotDot);
